import Marquee from "./Marquee";

export default Marquee;
